import styled, { css } from 'vue-styled-components'
import color from '@helpers/color.helper'
import texthelper from '@helpers/text.helper'

const genCssFont = (style = {}) => {
  return `
    ${style.color && `color: ${color.getColor(style.color)};`}
    ${style.family && `font-family: '${style.family}';`}
    ${style.size && `font-size: ${style.size}px;`}
    ${style.isItalic ? 'font-style: italic;' : 'font-style: normal;'}
    ${style.isBold ? 'font-weight: bold;' : 'font-weight: normal;'}
    /*${style.isUnderline ? 'text-decoration: underline;' : ''}*/
  `
}
const genCssFontSize = (style = {}) => {
  return `${style.size && `font-size: ${style.size}px;`}`
}
const genCssFontMobile = (size = 0) => {
  return `${size && `font-size: ${texthelper.responsiveFontSize(size)}px;`}`
}


// FontFace
const getCustomFonts = (customFonts) => {
  return css`
    ${Object.entries(customFonts).map((font) => `
    @font-face {
      font-family: ${font[1].name};
      src: url(${font[1].url});
    };
    `).join('')}  
  `
}

// Color
const TemplateColor = (templateColor = {}) => {
  return css`
  ${Object.entries(templateColor).map(([key, val]) => `${key}: ${val}`).join(';')};
  `
}

// background
const TemplateBackground = (templateBackground = {}) => {
  if (templateBackground.type == 'color') {
    return css`${templateBackground.color && `background-color: ${color.getColor(templateBackground.color, templateBackground.colorAlpha)};`}
  `
  } else if (templateBackground.type == 'image') {

    switch (templateBackground.imageRepeat) {
      case 'fill':
        return css`
          ${templateBackground.imageUrl && `background: linear-gradient(${color.getColor(templateBackground.backgroundImageColor,100-templateBackground.backgroundImageTransparent)},${color.getColor(templateBackground.backgroundImageColor,100-templateBackground.backgroundImageTransparent)}), url("${templateBackground.imageUrl && templateBackground.imageUrl.replace('{{size}}', '0')}");  `}
          ${templateBackground.imagePos && `background-position: ${templateBackground.imagePos};`}
          background-repeat : no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-attachment: fixed;
          `;
      case 'original':
        return css`
          ${templateBackground.imageUrl && `background: linear-gradient(${color.getColor(templateBackground.backgroundImageColor,100-templateBackground.backgroundImageTransparent)},${color.getColor(templateBackground.backgroundImageColor,100-templateBackground.backgroundImageTransparent)}), url("${templateBackground.imageUrl && templateBackground.imageUrl.replace('{{size}}', '0')}");  `}
          ${templateBackground.imagePos && `background-position: ${templateBackground.imagePos};`}
          background-repeat : no-repeat;
          background-attachment: fixed;
          `;
      case 'tiles':
        return css`
          ${templateBackground.imageUrl && `background: linear-gradient(${color.getColor(templateBackground.backgroundImageColor,100-templateBackground.backgroundImageTransparent)},${color.getColor(templateBackground.backgroundImageColor,100-templateBackground.backgroundImageTransparent)}), url("${templateBackground.imageUrl && templateBackground.imageUrl.replace('{{size}}', '0')}");  `}
          `;
      default:
        return '';
    }

  } else if(templateBackground.type == 'gradient') {
    return css`
    ${`background: linear-gradient(
      ${templateBackground.gradientRotate}deg,
      ${color.getColor(templateBackground.gradientColor1, templateBackground.gradientColor1Alpha)} 0%,
      ${color.getColor(templateBackground.gradientColor2, templateBackground.gradientColor2Alpha)} 100% ) !important`
    } 
    `
  }
}

// Text
const TemplateFonts = (templateFonts = {}, templateFontsLanguage = {}) => {
  return css`
  .theme-font h1, .theme-font .h1 { ${genCssFont({ ...templateFonts['heading1'], ...templateFontsLanguage['heading1'] })} }
  .theme-font h2, .theme-font .h2 { ${genCssFont({ ...templateFonts['heading2'], ...templateFontsLanguage['heading2'] })} }
  .theme-font h3, .theme-font .h3 { ${genCssFont({ ...templateFonts['heading3'], ...templateFontsLanguage['heading3'] })} }
  .theme-font h4, .theme-font .h4 { ${genCssFont({ ...templateFonts['heading4'], ...templateFontsLanguage['heading4'] })} }
  .theme-font p, .theme-font .p { ${genCssFont({ ...templateFonts['paragraph1'], ...templateFontsLanguage['paragraph1'] })} }
  .theme-font .link, .theme-font a, .theme-font .a { ${genCssFont({ ...templateFonts['link'], ...templateFontsLanguage['link'] })} }
  @media only screen and (max-width: 767px) {
    .theme-font h1, .theme-font .h1 { ${genCssFontMobile(templateFontsLanguage['heading1'].size)} }
    .theme-font h2, .theme-font .h2 { ${genCssFontMobile(templateFontsLanguage['heading2'].size)} }
    .theme-font h3, .theme-font .h3 { ${genCssFontMobile(templateFontsLanguage['heading3'].size)} }
    .theme-font h4, .theme-font .h4 { ${genCssFontMobile(templateFontsLanguage['heading4'].size)} }
    .theme-font p, .theme-font .p { ${genCssFontMobile(templateFontsLanguage['paragraph1'].size)} }
    .theme-font .link, .theme-font a, .theme-font .a { ${genCssFontMobile(templateFontsLanguage['link'].size)} }
  } 
  `
}

// TextEditor
const TextEditor = () => {
  return css`
  .ql-container {
    font-size: unset;
  }
  .ql-editor {
    padding: unset;
    white-space: normal;
    word-break: break-word;
    > * {
      cursor: unset !important;
    }
  }
  .ql-editor.ql-blank::before {
    display: none;
  }
  `
}
const TextEditorFonts = (templateFonts = {}, templateFontsLanguage = {}) => {
  const cssHeading1 = genCssFont({ ...templateFonts['heading1'], ...templateFontsLanguage['heading1'] });
  const cssHeading2 = genCssFont({ ...templateFonts['heading2'], ...templateFontsLanguage['heading2'] });
  const cssHeading3 = genCssFont({ ...templateFonts['heading3'], ...templateFontsLanguage['heading3'] });
  const cssHeading4 = genCssFont({ ...templateFonts['heading4'], ...templateFontsLanguage['heading4'] });
  const cssParagraph1 = genCssFont({ ...templateFonts['paragraph1'], ...templateFontsLanguage['paragraph1'] });
  const cssParagraph2 = genCssFont({ ...templateFonts['paragraph2'], ...templateFontsLanguage['paragraph2'] });
  const cssParagraph3 = genCssFont({ ...templateFonts['paragraph3'], ...templateFontsLanguage['paragraph3'] });
  const cssLink = genCssFont({ ...templateFonts['link'], ...templateFontsLanguage['link'] });

  const cssHeading1_max30 = genCssFontSize({ size: Math.min(templateFontsLanguage['heading1'].size, 30) });
  const cssHeading2_max30 = genCssFontSize({ size: Math.min(templateFontsLanguage['heading2'].size, 30) });
  const cssHeading3_max30 = genCssFontSize({ size: Math.min(templateFontsLanguage['heading3'].size, 30) });
  const cssHeading4_max30 = genCssFontSize({ size: Math.min(templateFontsLanguage['heading4'].size, 30) });
  const cssParagraph1_max30 = genCssFontSize({ size: Math.min(templateFontsLanguage['paragraph1'].size, 30) });
  const cssParagraph2_max30 = genCssFontSize({ size: Math.min(templateFontsLanguage['paragraph2'].size, 30) });
  const cssParagraph3_max30 = genCssFontSize({ size: Math.min(templateFontsLanguage['paragraph3'].size, 30) });
  const cssLink_max30 = genCssFontSize({ size: Math.min(templateFontsLanguage['link'].size, 30) });

  return css`
  .ql-editor,
  .ql-editor p, 
  .ql-editor div, 
  .ql-editor h1, 
  .ql-editor h2, 
  .ql-editor h3, 
  .ql-editor h4 {
    line-height: 1.2;
  }

  .ql-editor a {
    font-family: unset;
    font-size: unset;
    color: unset;
    font-style: unset;
    font-weight: unset;
  }

  .ql-style-heading h1 { ${cssHeading1} }
  .ql-style-heading h2 { ${cssHeading2} }
  .ql-style-heading h3 { ${cssHeading3} }
  .ql-style-heading h4 { ${cssHeading4} }
  .ql-style-heading p { ${cssParagraph1} }

  .ql-style-template .ql-template-heading1 { ${cssHeading1} }
  .ql-style-template .ql-template-heading2 { ${cssHeading2} }
  .ql-style-template .ql-template-heading3 { ${cssHeading3} }
  .ql-style-template .ql-template-heading4 { ${cssHeading4} }
  .ql-style-template .ql-template-paragraph1 { ${cssParagraph1} }
  .ql-style-template .ql-template-paragraph2 { ${cssParagraph2} }
  .ql-style-template .ql-template-paragraph3 { ${cssParagraph3} }
  .ql-style-template .ql-template-link { ${cssLink} }

  .ql-style-font .ql-font-heading1 { ${cssHeading1} }
  .ql-style-font .ql-font-heading2 { ${cssHeading2} }
  .ql-style-font .ql-font-heading3 { ${cssHeading3} }
  .ql-style-font .ql-font-heading4 { ${cssHeading4} }
  .ql-style-font .ql-font-paragraph1 { ${cssParagraph1} }
  .ql-style-font .ql-font-paragraph2 { ${cssParagraph2} }
  .ql-style-font .ql-font-paragraph3 { ${cssParagraph3} }
  .ql-style-font .ql-font-link { ${cssLink} }

  .ql-style-heading.ql-style-fs-max-30 h1 { ${cssHeading1_max30} }
  .ql-style-heading.ql-style-fs-max-30 h2 { ${cssHeading2_max30} }
  .ql-style-heading.ql-style-fs-max-30 h3 { ${cssHeading3_max30} }
  .ql-style-heading.ql-style-fs-max-30 h4 { ${cssHeading4_max30} }
  .ql-style-heading.ql-style-fs-max-30 p { ${cssParagraph1_max30} }
  
  .ql-style-template.ql-style-fs-max-30 .ql-template-heading1 { ${cssHeading1_max30} }
  .ql-style-template.ql-style-fs-max-30 .ql-template-heading2 { ${cssHeading2_max30} }
  .ql-style-template.ql-style-fs-max-30 .ql-template-heading3 { ${cssHeading3_max30} }
  .ql-style-template.ql-style-fs-max-30 .ql-template-heading4 { ${cssHeading4_max30} }
  .ql-style-template.ql-style-fs-max-30 .ql-template-paragraph1 { ${cssParagraph1_max30} }
  .ql-style-template.ql-style-fs-max-30 .ql-template-paragraph2 { ${cssParagraph2_max30} }
  .ql-style-template.ql-style-fs-max-30 .ql-template-paragraph3 { ${cssParagraph3_max30} }
  .ql-style-template.ql-style-fs-max-30 .ql-template-link { ${cssLink_max30} }

  .ql-style-font.ql-style-fs-max-30 .ql-font-heading1 { ${cssHeading1_max30} }
  .ql-style-font.ql-style-fs-max-30 .ql-font-heading2 { ${cssHeading2_max30} }
  .ql-style-font.ql-style-fs-max-30 .ql-font-heading3 { ${cssHeading3_max30} }
  .ql-style-font.ql-style-fs-max-30 .ql-font-heading4 { ${cssHeading4_max30} }
  .ql-style-font.ql-style-fs-max-30 .ql-font-paragraph1 { ${cssParagraph1_max30} }
  .ql-style-font.ql-style-fs-max-30 .ql-font-paragraph2 { ${cssParagraph2_max30} }
  .ql-style-font.ql-style-fs-max-30 .ql-font-paragraph3 { ${cssParagraph3_max30} }
  .ql-style-font.ql-style-fs-max-30 .ql-font-link { ${cssLink_max30} }

  .ql-editor [data-ql-line-size="8px"] { font-size: 8px; }
  .ql-editor [data-ql-line-size="9px"] { font-size: 9px; }
  .ql-editor [data-ql-line-size="10px"] { font-size: 10px; }
  .ql-editor [data-ql-line-size="11px"] { font-size: 11px; }
  .ql-editor [data-ql-line-size="12px"] { font-size: 12px; }
  .ql-editor [data-ql-line-size="13px"] { font-size: 13px; }
  .ql-editor [data-ql-line-size="14px"] { font-size: 14px; }
  .ql-editor [data-ql-line-size="15px"] { font-size: 15px; }
  .ql-editor [data-ql-line-size="16px"] { font-size: 16px; }
  .ql-editor [data-ql-line-size="17px"] { font-size: 17px; }
  .ql-editor [data-ql-line-size="18px"] { font-size: 18px; }
  .ql-editor [data-ql-line-size="19px"] { font-size: 19px; }
  .ql-editor [data-ql-line-size="20px"] { font-size: 20px; }
  .ql-editor [data-ql-line-size="22px"] { font-size: 22px; }
  .ql-editor [data-ql-line-size="24px"] { font-size: 24px; }
  .ql-editor [data-ql-line-size="26px"] { font-size: 26px; }
  .ql-editor [data-ql-line-size="28px"] { font-size: 28px; }
  .ql-editor [data-ql-line-size="30px"] { font-size: 30px; }
  .ql-editor [data-ql-line-size="32px"] { font-size: 32px; }
  .ql-editor [data-ql-line-size="34px"] { font-size: 34px; }
  .ql-editor [data-ql-line-size="36px"] { font-size: 36px; }
  .ql-editor [data-ql-line-size="40px"] { font-size: 40px; }
  .ql-editor [data-ql-line-size="44px"] { font-size: 44px; }
  .ql-editor [data-ql-line-size="48px"] { font-size: 48px; }
  .ql-editor [data-ql-line-size="52px"] { font-size: 52px; }
  .ql-editor [data-ql-line-size="56px"] { font-size: 56px; }
  .ql-editor [data-ql-line-size="60px"] { font-size: 60px; }
  .ql-editor [data-ql-line-size="66px"] { font-size: 66px; }
  .ql-editor [data-ql-line-size="72px"] { font-size: 72px; }
  .ql-editor [data-ql-line-size="80px"] { font-size: 80px; }
  .ql-editor [data-ql-line-size="100px"] { font-size: 100px; }
  .ql-editor [data-ql-line-size="140px"] { font-size: 140px; }
  .ql-editor [data-ql-line-size="160px"] { font-size: 160px; }
  .ql-editor [data-ql-line-size="180px"] { font-size: 180px; }
  .ql-editor [data-ql-line-size="200px"] { font-size: 200px; }
  `
}

const WrapperProps = {
  templateColor: Object,
  templateFonts: Object,
  templateFontsLanguage: Object,
  templateBackground: Object,
  device: String,
  customFonts: Array
}
const Wrapper = styled('div', WrapperProps)`
${({ customFonts }) => getCustomFonts(customFonts)}
.openMenu3overflowhide {
  overflow-x: hidden;
}
.openMenu3 {
  -webkit-transform: translate3d(300px, 0, 0);
  -moz-transform: translate3d(300px, 0, 0);
  -ms-transform: translate3d(300px, 0, 0);
  transform: translate3d(300px, 0, 0);
}
div.section-body {
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
#section-content {
  position: relative;
}
${({ templateColor }) => TemplateColor(templateColor)}
${({ templateBackground }) => TemplateBackground(templateBackground)}
${({ templateFonts, templateFontsLanguage }) => TemplateFonts(templateFonts, templateFontsLanguage)}
${() => TextEditor()}
${({ templateFonts, templateFontsLanguage }) => TextEditorFonts(templateFonts, templateFontsLanguage)}
`;

export {
  Wrapper,

}